import { FC } from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';

export type Option = {
  label: string;
  value: string;
};
type Props = {
  name: string;
  options: Option[];
  onChange: (value: string) => void;
  value: string;
  disabled?: boolean;
};
const Switch: FC<Props> = ({
  name,
  options = [],
  onChange,
  value,
  disabled,
}) => {
  return (
    <div className={styles.host}>
      {options.map((v) => {
        const checked = v.value === value;
        return (
          <label
            key={v.value}
            className={classNames(
              styles.label,
              checked && styles.checked,
              disabled && styles.disabled
            )}
          >
            <input
              type="radio"
              name={name}
              value={v.value}
              checked={checked}
              disabled={disabled}
              onChange={(e) => {
                onChange(e.target.value);
              }}
              className={styles.input}
            />
            {v.label}
          </label>
        );
      })}
    </div>
  );
};

export default Switch;
